import Tabs from "../../../../src/pages/home/base/assurance/tabs/common-issues.md";
import * as React from 'react';
export default {
  Tabs,
  React
};